import { useMutation, useQueryClient } from "react-query";
import { getApplicationNoticePreview, sendApplicationNotice } from "@/api/ApplicationOrders/application-notice-api";

export const useApplicationNoticePreview = () => {
	return useMutation(({ orderApplicationId, distributionLists }) => getApplicationNoticePreview(orderApplicationId, distributionLists));
};

export const useSendApplicationNotice = () => {
	const queryClient = useQueryClient();

	return useMutation(({ orderApplicationId, distributionLists }) => sendApplicationNotice(orderApplicationId, distributionLists), {
		onSuccess: () => {
			queryClient.invalidateQueries(["application_orders"]);
		},
	});
};
